import { Component } from "@angular/core";
import { ActivatedRoute,Router } from "@angular/router";
import { ToastService } from "angular-toastify";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { BankDetails } from "@interfaces/bankDetails.interface";
import { BankDetailsService } from "@services/bankDetails.service";

@Component({
	moduleId: module.id,
	selector: "bankDetails-id",
	styleUrls: ["bankDetails-id.css"],
	templateUrl: "bankDetails-id.html"
})
export class BankDetailsIdAdminComponent {
	createEnabled = true;
	editEnabled = true;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	item: BankDetails = new BankDetails();
	itemId = 0;
	itemType = "Bank Details";
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	statuses: any;
	title: string = "View " + this.itemType;

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private itemService: BankDetailsService) {
		this.buildButtons("view");
		this.route.params
			.subscribe((params) => {
				if (params.id != "create") {
					if (params.id.split("_").length > 1) {
						this.itemId = params.id.split("_")[0];
						this.getItem(this.itemId);
						this.edit();
					} else {
						this.itemId = params.id;
						this.getItem(params.id);
					}
				} else {
					this.create();					
				}
			});
	}

	buildButtons(mode: string) {
		if (mode == "edit" && this.editEnabled) {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "create" && this.createEnabled) {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "view") {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];	
		}
	}

	cancelEditing() {
		if (confirm("Are you sure you wish to switch modes? Unsaved changes will be discarded.") == false) {
			return;
		}
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}

	create() {
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.itemService.createSingle(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Created " + this.itemType);
					this.item = new BankDetails();
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	getItem(itemId: number) {
		this.itemService.getSingleById(itemId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
				},
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	updateItem() {
		this.itemService.updateSingleById(this.item.id,this.item)
			.subscribe(
				() => this.toastService.success("Successfully Updated "),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}
}